import type { Component } from "solid-js";
import InlineMessage from "../components/inlineMessage/InlineMessage";
import { TextAndIconButton, TextButton } from "../components/button/Button";
import { useTranslation } from "../state/i18n";
import * as Sentry from "@sentry/solid";
import { Title } from "@solidjs/meta";
import { directUserToSupport } from "../utils/supportUtil";
import moreappLogo from "../assets/moreapp-logo.svg";

type ErrorPageProps = {
  err: Error;
};
const GlobalErrorPage: Component<ErrorPageProps> = (props) => {
  const { t } = useTranslation();

  const navigateToHome = () => (window.location.href = "/");

  return (
    <>
      <Title>MoreApp - {t(($) => $.GLOBAL_ERROR_PAGE_PAGE_TITLE)}</Title>
      <main class="flex h-screen flex-col">
        <div class="mx-auto flex w-180 flex-col items-center gap-10 bg-surface-default py-21">
          <img src={moreappLogo} alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)} />

          <div class="mt-4 text-center">
            <h1 class="mb-2 text-header-3xl text-primary">{t(($) => $.GLOBAL_ERROR_PAGE_TITLE)}</h1>
            <p class="text-medium-regular text-secondary">
              {t(($) => $.GLOBAL_ERROR_PAGE_ERROR_DESCRIPTION, { errorMessage: props.err.message })}
            </p>
            <p class="text-medium-regular text-secondary">{t(($) => $.GLOBAL_ERROR_PAGE_ERROR_SUGGESTION)}</p>
          </div>

          <InlineMessage variant="informative">
            <b>Trace ID:</b> {Sentry.getCurrentScope().getPropagationContext().traceId}
          </InlineMessage>

          <div class="flex gap-2">
            <TextAndIconButton
              text={t(($) => $.GLOBAL_ERROR_PAGE_ACTIONS_RETURN_HOME_LABEL)}
              icon="home"
              onClick={navigateToHome}
            />
            <TextButton
              text={t(($) => $.GLOBAL_ERROR_PAGE_ACTIONS_CONTACT_SUPPORT_LABEL)}
              variant="secondary"
              onClick={directUserToSupport}
            />
          </div>
        </div>
        <div class="grow bg-surface-extra-subtle p-16">
          <div class="mx-auto max-w-desktop min-w-180 rounded-sm border border-default bg-surface-default p-6">
            <pre class="font-fira whitespace-pre-wrap">{props.err.stack}</pre>
          </div>
        </div>
      </main>
    </>
  );
};

export default GlobalErrorPage;
